import {AfterViewInit, ChangeDetectorRef, Component, OnInit} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ConstantsService } from 'app/services/constants-service';
import {ActivatedRoute, Router} from '@angular/router';
import {EntityDetailsService} from '../../entities/details/entity-details.service';
import {EntityIdDetails} from '../../shared/models/entity-id-details.model';
import {CookieService} from '../../services/cookie.service';

@Component({
  selector: 'app-workflow',
  templateUrl: './workflow.component.html',
  styleUrls: ['./workflow.component.css'],
})
/**
 * Component to display the payment management view.
 */
export class WorkflowComponent implements AfterViewInit, OnInit   {
  private urlWorkflow = ConstantsService.WORKFLOW_URL;
  public entityIdDetails: EntityIdDetails;

    constructor(
    private sanitizer: DomSanitizer,
    private ref: ChangeDetectorRef,
    private router: ActivatedRoute,
    public entityDetailsService: EntityDetailsService,
    private cookieService: CookieService
  ) {
      this.entityIdDetails = this.entityDetailsService.getEntityIdDetails();
    }

  public safeUrl = () => {
    const access = this.cookieService.get(ConstantsService.COOKIE_ACCESS_TOKEN);
    return this.sanitizer
      .bypassSecurityTrustResourceUrl(`${this.urlWorkflow}?entity=${this.entityIdDetails.entityId}&access=${access}`);
  }

  ngAfterViewInit(): void {

    this.ref.detach();
  }

  ngOnInit(): void {
    this.entityIdDetails = this.entityDetailsService.getEntityIdDetails();
  }
}



// WEBPACK FOOTER //
// ./src/app/workflow/workflow/workflow.component.ts